module.exports = __webpack_public_path__ + "img/JU.19a4793e.png";